import { setAgStore } from 'state/cookies/agStore';
import { setCheckoutToken } from 'state/localStorage/checkoutToken';
import { setAgLang } from 'state/cookies/agLang';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { getQueryParam } from './getQueryParam';

export function useSetDataFromURL() {
  const router = useRouter();
  const storeUrlParam = getQueryParam(router.query, 'ag-store', '');
  const langUrlParam = getQueryParam(router.query, 'ag-lang', '');
  const checkoutToken = getQueryParam(router.query, 'ag-checkout-token', '');

  useEffect(() => {
    if (storeUrlParam) {
      setAgStore(storeUrlParam);
    }

    if (langUrlParam) {
      setAgLang(langUrlParam);
    }

    if (storeUrlParam && checkoutToken) {
      setCheckoutToken(storeUrlParam, checkoutToken);
    }
  }, [checkoutToken, langUrlParam, storeUrlParam]);
}
